module.exports = "export default function transformer(file, api) {\r\n  const j = api.jscodeshift;\r\n  const {expression, statement, statements} = j.template;\r\n\r\n  return j(file.source)\r\n    .find(j.Identifier)\r\n    .replaceWith(\r\n      p => j.identifier(p.node.name.split('').reverse().join(''))\r\n    )\r\n    .toSource();\r\n};\r\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/parsers/js/transformers/jscodeshift/codeExample.txt
 ** module id = ./src/parsers/js/transformers/jscodeshift/codeExample.txt
 ** module chunks = 0
 **/